import {Box, Stack, Typography} from '@mui/material';
import React from 'react';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import {ArrToggle} from '../../../../common/arr-toggle/ArrToggle';
import {useTranslation} from 'react-i18next';
import TextPropertyToolbar from '../../common/text-property-toolbar/TextPropertyToolbar';
import TagsSection from '../../common/tags-section/TagsSection';
import {TagItem} from '../../../../../api/types/production.type';
import './PlaceholderForPrivDocModal.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
interface PlaceholderForPrivDocModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
  onOpenTags: () => void;
  onOpenInsertField: (currentText: string) => void;
  placeholderText: string;
  onPlaceholderTextChange: (text: string) => void;
  isPlaceholderEnabled: boolean;
  onPlaceholderToggle: (enabled: boolean) => void;
  selectedTags: TagItem[];
  onTagsChange: (tags: TagItem[]) => void;
  disabled?: boolean;
}

export const PlaceholderForPrivDocModal: React.FC<
  PlaceholderForPrivDocModalProps
> = ({
  isOpen,
  onClose,
  onProceed,
  onOpenTags,
  onOpenInsertField,
  placeholderText,
  isPlaceholderEnabled,
  onPlaceholderToggle,
  onPlaceholderTextChange,
  selectedTags,
  onTagsChange,
  disabled = false,
}) => {
  const {t} = useTranslation();

  if (!isOpen) return null;

  const modalFooter = (
    <div
      className="arr-placeholder-for-priv-docs-modal-footer"
      data-testid={`placeholder-for-priv-doc-modal-cancel-proceed`}
    >
      <ArrButton
        size="large"
        variant="secondary"
        onClick={onClose}
        disabled={disabled}
        dataTestId="placeholder-for-priv-doc-modal-cancel-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.cancel'
        )}
      </ArrButton>
      <ArrButton
        size="large"
        variant="primary"
        onClick={onProceed}
        disabled={disabled}
        dataTestId="placeholder-for-priv-doc-modal-proceed-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.proceed'
        )}
      </ArrButton>
    </div>
  );

  return (
    <ArrModal
      headerTitle={t(
        'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.title'
      )}
      headerTitleClassName="typo-text headline3_size text-headings"
      showModal={isOpen}
      onClose={onClose}
      footer={modalFooter}
      dataTestId="placeholderforprivdoc-modal"
    >
      <div
        className="arr-placeholder-for-priv-docs-modal"
        style={{display: 'flex', flexDirection: 'column'}}
        data-testid={`placeholder-for-priv-doc-modal-checkbox-label`}
      >
        <Box>
          <Stack
            className="toggle-option"
            direction="row"
            spacing={1}
            alignItems="center"
          >
            <Typography
              className="typo-text label2_size text-headings"
              data-testid={`placeholder-for-priv-doc-modal-checkbox-label-text`}
            >
              {t(
                'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.checkboxLabel'
              )}
            </Typography>
            <ArrToggle
              value={isPlaceholderEnabled}
              onChange={(e) =>
                !disabled && onPlaceholderToggle(e.target.checked)
              }
              toggleSize="medium"
              disabled={disabled}
              dataTestId="placeholder-enabled-toggle"
            />
          </Stack>

          {isPlaceholderEnabled && (
            <Stack direction="column" className="placeholder-config">
              <Box className="config-row">
                <Box className="config-field">
                  <TagsSection
                    headerTitle={t(
                      'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.tagsSelector.title'
                    )}
                    buttonTitle={t(
                      'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.tagsSelector.selectTags'
                    )}
                    selectedTags={selectedTags}
                    onTagsChange={onTagsChange}
                    onAddTagsClick={onOpenTags}
                    disabled={disabled}
                  />
                </Box>
                <Box className="config-field">
                  <TextPropertyToolbar
                    dataTestId="tag-section"
                    insertFieldInside="modal"
                    variant="with-title"
                    title={t(
                      'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.placeholderTextSelector.title'
                    )}
                    toolbarText={placeholderText}
                    onToolbarTextChange={onPlaceholderTextChange}
                    onInsertField={(field) =>
                      !disabled &&
                      onPlaceholderTextChange(placeholderText + `$${field}$`)
                    }
                    onInsertFieldClick={() =>
                      !disabled && onOpenInsertField(placeholderText)
                    }
                    placeholder={t(
                      'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.placeholderTextSelector.placeholder'
                    )}
                    disabled={disabled}
                  />
                </Box>
              </Box>
            </Stack>
          )}
        </Box>
      </div>
    </ArrModal>
  );
};
